import { LoginWebsiteAttributesEntry, LoginWebsiteProtocol } from 'persistable-types';

export default function getWebsiteAttributesEntry(
  unnormalizedWebsite: string,
): LoginWebsiteAttributesEntry {
  // NOTE: Make sure that optional entries are actually not present in the object, not present with
  // a value of undefined. TS treats both the same, but the result is going to be spread to be
  // merged with the preexisting old object, and undefined values would overwrite there.
  const websiteAttributesEntry: LoginWebsiteAttributesEntry = {};
  const protocol = getProtocol(unnormalizedWebsite);
  if (protocol) {
    websiteAttributesEntry.protocol = protocol;
  }
  return websiteAttributesEntry;
}

function getProtocol(website: string): LoginWebsiteProtocol | null {
  let url: URL;
  try {
    url = new URL(website);
  } catch {
    return null;
  }
  switch (url.protocol) {
    case 'http:':
      return LoginWebsiteProtocol.http;
    case 'https:':
      return LoginWebsiteProtocol.https;
    case 'winbox:':
      return LoginWebsiteProtocol.winbox;
    default:
      return null;
  }
}
